module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBlack.4478d1f6.ttf";